(() => {
  // Phase 2 TODO: add focus trap. For now, just open/close + ESC + outside-click.

  const init = () => {
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menu || menu.dataset.mobileMenuReady === '1') return;
    menu.dataset.mobileMenuReady = '1';

    const open = () => {
      menu.dataset.open = 'true';
      menu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const close = () => {
      menu.dataset.open = 'false';
      menu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-mobile-menu-toggle]')) {
        e.preventDefault();
        open();
      } else if (e.target.closest('[data-mobile-menu-close]')) {
        e.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menu.dataset.open === 'true') close();
    });

    // Close after navigating via a link in the menu.
    menu.addEventListener('click', (e) => {
      if (e.target.closest('a[href]')) close();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
